import { Avatar, Card, Group, Stack, Text } from '@mantine/core'
import {
  displayUser,
  initialsFromSenderFallback,
  workspaceUserInitials,
} from '@/components/tickets/TicketMessageThread'
import { resolveOperatorAvatarSrc } from '@/lib/dashboard-ai-operator'
import { formatWhen } from '@/lib/ticket-display'
import type { TicketViewerRow, WorkspaceUserRow } from '@/types/api'

type TicketViewersCardProps = {
  viewers: TicketViewerRow[]
  usersById: Map<string, WorkspaceUserRow>
  currentUserId?: string | null
}

export function TicketViewersCard({ viewers, usersById, currentUserId }: TicketViewersCardProps) {
  return (
    <Card
      withBorder
      padding="sm"
      radius="md"
      style={{
        background:
          'light-dark(var(--mantine-color-violet-0), color-mix(in srgb, var(--mantine-color-violet-9) 18%, var(--mantine-color-dark-7)))',
        borderColor:
          'light-dark(var(--mantine-color-violet-2), color-mix(in srgb, var(--mantine-color-violet-6) 45%, transparent))',
      }}
    >
      <Text fw={600} size="xs" mb={6}>
        Просматривают
      </Text>
      {viewers.length === 0 ? (
        <Text size="xs" c="dimmed">
          Никто
        </Text>
      ) : (
        <Stack gap={4}>
          {viewers.map((viewer) => {
            const workspaceUser = usersById.get(viewer.user_id)
            const avatarSrc = resolveOperatorAvatarSrc(
              workspaceUser
                ? {
                    operator_name: displayUser(workspaceUser),
                    operator_email: workspaceUser.email,
                    avatar_url: workspaceUser.avatar_url,
                  }
                : {
                    operator_name: viewer.user_name,
                    operator_email: null,
                    avatar_url: null,
                  },
            )
            const initials = workspaceUser
              ? workspaceUserInitials(workspaceUser)
              : initialsFromSenderFallback(viewer.user_name, null)
            return (
              <Group key={viewer.user_id} gap={8} wrap="nowrap" align="center">
                <Avatar
                  src={avatarSrc}
                  radius="xl"
                  size={22}
                  color="violet"
                  variant={avatarSrc ? 'filled' : 'light'}
                  style={{ flexShrink: 0 }}
                >
                  {initials}
                </Avatar>
                <Text size="xs" lineClamp={1} style={{ flex: 1, minWidth: 0 }}>
                  {viewer.user_name}
                  {viewer.user_id === currentUserId ? ' (вы)' : ''}
                </Text>
                <Text size="xs" c="dimmed" style={{ flexShrink: 0 }}>
                  {viewer.last_activity ? formatWhen(viewer.last_activity) : ''}
                </Text>
              </Group>
            )
          })}
        </Stack>
      )}
    </Card>
  )
}
